export default __webpack_public_path__ + "static/media/Thug's Mask of the Hidden Tomb.2c45c84a.jpg";